import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

import type { NotificationState } from '../../store';

const initialState: NotificationState = {
  notification: [],
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    addSuccessNotification(state, action: PayloadAction<string>) {
      state.notification = state.notification.concat([
        {
          id: uuidv4(),
          message: action.payload,
          color: 'success',
        },
      ]);
    },
    addErrorNotification(state, action: PayloadAction<string>) {
      state.notification = state.notification.concat([
        {
          id: uuidv4(),
          message: action.payload,
          color: 'error',
        },
      ]);
    },
    removeNotification(state, action: PayloadAction<string>) {
      state.notification = state.notification.filter((notificationSlice) => notificationSlice.id !== action.payload);
    },
  },
});

export type { NotificationState };

const { addSuccessNotification, addErrorNotification, removeNotification } = notificationSlice.actions;

export { addSuccessNotification, addErrorNotification, removeNotification };

export default notificationSlice.reducer;
